module.exports = __webpack_public_path__ + "img/clh.3147eaf0.jpg";